import { RiskRecordsTable } from '@src/entities/RiskRecord/ui/components/tables/RiskRecords';
import { useWizardContext } from '@src/features/ActionPaths/Wizard/context';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import React from 'react';

/**
 * RiskRecords
 *
 * Provides the user with a screen to browse the risk records found based on the entrance criteria (filters) specified.
 *
 * @param form
 * @returns {Element}
 * @constructor
 */
export function RiskRecords({ form = {} }) {
  const { actionPath, currentStep } = useWizardContext();

  const criteria = form?.getValues('criteria');

  return (
    <ErrorHandler location="src/features/ActionPaths/Wizard/components/steps/RiskRecords/RiskRecords.jsx">
      <Grid>
        <Grid.Col
          span={{
            xs: '100%',
          }}
        >
          <Flex alignContent="flex-start" direction="column">
            <Flex alignItems="center" direction="row">
              <Heading offset={1}>{currentStep?.label}</Heading>
            </Flex>
            <p>{currentStep?.description}</p>
          </Flex>
        </Grid.Col>
        <Grid.Col
          span={{
            xs: '100%',
          }}
        >
          <RiskRecordsTable
            allowExport
            context="entrance"
            criteria={criteria}
            currentEntity={{
              id: actionPath?.id,
              name: actionPath?.name,
              type: 'actionPath',
            }}
            showAnalyzeRisks
            showFilters
            showTotalRecords
          />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
